import { useEffect, useState } from 'react'

const useCanShare = () => {
  const [canShare, setCanShare] = useState(false)

  useEffect(() => {
    if (window.navigator.share) setCanShare(true)
  }, [setCanShare])

  return canShare
}

export default useCanShare
